import React, { useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { uniqueId } from 'lodash';
import ReactJWPlayer from 'react-jw-player';
import Hls from 'hls.js';
import * as labels from '../../multilingual.json'
let evAudioList = [];

const ReactJWPlayerContainer = props => {
	const { setAudiosCB } = props
	const HLS = new Hls();
	Hls.DefaultConfig.enableWorker = false;
	const [playerID,] = useState(uniqueId("pId-"))
	const [audioLoaded, setAudioLoaded] = useState(false);
	const [audioTList , setAudioTList] = useState([]);
	const [preferredLang, setPreferredLang] = useState(props.lang)
	const playerReady = audioLoaded && window.jwplayer && window.jwplayer(playerID) && window.jwplayer(playerID).getAudioTracks
  
	useEffect(()=> {
		if(props.vType !== "video") {
			const reCheckAudio = setInterval(()=> {
				readManifestAudios();
			},10000);

			return ()=> clearInterval(reCheckAudio);
		}
	});

	useEffect(()=> {
		setPreferredLang(props.lang)
	},[props.lang]);

	useEffect(()=> {
		setPreferredLang(props.current_lang)
	},[props.current_lang]);

	useEffect(()=> {
		evAudioList = audioTList;
		setAudiosCB(audioTList);
	},[audioTList, setAudiosCB]);

	const readManifestAudios = ()=> {
		if(Hls.isSupported() && props.playlist.file !== undefined) {
			HLS.loadSource(props.playlist.file);

			HLS.on(Hls.Events.MANIFEST_PARSED, function (e, dt) {
				const res = dt.audioTracks.filter(({ lang: lang1 }) => !evAudioList.some(({ lang: lang2 }) => lang2 === lang1));

				if(evAudioList.length > 0 && res.length > 0) {
					setAudioTList(dt.audioTracks);
					setTimeout(()=> {
						window.location.reload();
					},500);
				}
			}
		)};
	}

	const setAudioTrackToPreferredLang = () => {
		const player = window.jwplayer(playerID);
		const curLang = preferredLang.toUpperCase();

		const flAudioTrack = audioTList.find(obj => {
			const curLang = obj.lang !== undefined ? obj.lang.toUpperCase() : obj.lang;
			return curLang === undefined ||  curLang === "FLOOR" || curLang === "MUL" || curLang === "UND";
		});

		const frAudioTrack = audioTList.find(obj => {
			const curLang = obj.lang !== undefined ? obj.lang.toUpperCase() : obj.lang;
			return curLang === "FR";
		});

		const enAudioTrack = audioTList.find(obj => {
			const curLang = obj.lang !== undefined ? obj.lang.toUpperCase() : obj.lang;
			return curLang === "EN";
		});

		switch(curLang) {
			case "EN":
				enAudioTrack !== undefined ? player.setCurrentAudioTrack(parseInt(enAudioTrack.id)) : player.setCurrentAudioTrack(parseInt(flAudioTrack.id));
				break;
			case "FR":
				frAudioTrack !== undefined ? player.setCurrentAudioTrack(parseInt(frAudioTrack.id)) : player.setCurrentAudioTrack(parseInt(flAudioTrack.id));
				break;
			case "FLOOR":
			case undefined:
				player.setCurrentAudioTrack(parseInt(flAudioTrack.id));
				break;
			default:
				enAudioTrack !== undefined ? player.setCurrentAudioTrack(parseInt(enAudioTrack.id)) : player.setCurrentAudioTrack(parseInt(flAudioTrack.id));
		}

		if(props.btnClicked) {
			player.play();
			props.audioClickedCB(false);
		}
	}

	useEffect(() => {
		if (playerReady) {
			setAudioTrackToPreferredLang()
		}
	}, [playerReady, preferredLang, playerID])

	const onResume = () => {
		if(props.setShowCPACTV) {
			props.setShowCPACTV(false)
		}
		if(playerID && audioLoaded) {
			setAudioTrackToPreferredLang();
		}
		fixAudioTracksButtonLabels()
	}

	const onPlay = () => {
		if(!audioLoaded) {
			onAudioTracksLoaded();
		}
		if(props.setShowCPACTV) {
			props.setShowCPACTV(false)
		}
		if(playerID && audioLoaded) {
			setAudioTrackToPreferredLang();
		}
		fixAudioTracksButtonLabels()
	}

	const onAudioTracksLoaded = () => {
		if(playerID) {
			if(Hls.isSupported() && props.playlist.file !== undefined) {
				HLS.loadSource(props.playlist.file);

				HLS.on(Hls.Events.MANIFEST_PARSED, function (e, dt) {
					setAudioTList(dt.audioTracks);
					setAudioLoaded(true);
				});
			}else {
				const player = window.jwplayer(playerID);
				const audioTracks = player.getAudioTracks();

				const newAudioTracks = audioTracks.map((track, i ) => {
					return {...track, lang: track.language === "" ? "Floor" : track.language , id: i }
				});

				setAudioTList(newAudioTracks);

				if (newAudioTracks.length > 0 ) {
					setAudioLoaded(true);
					setAudioTrackToPreferredLang();
				}
			}
		}
	}

	const fixAudioTracksButtonLabels = () => {
		const english = props.current_lang === "en" ? labels.ENGLISH_en : props.current_lang === "fr" ? labels.ENGLISH_fr : "eng"
		const french = props.current_lang === "en" ? labels.FRENCH_en : props.current_lang === "fr" ? labels.FRENCH_fr : "fre"
		const multi = props.current_lang === "en" ? labels.FLOOR_en : props.current_lang === "fr" ? labels.FLOOR_fr : "mul"

		// per Vualto: "It’s a bit of a hack but it’s a way to ensure that the tracks are always labelled correctly."
		const langBtns = document.querySelectorAll('.jw-settings-submenu-audioTracks .jw-settings-content-item')
		if (audioLoaded && langBtns && langBtns.length > 0) {
			langBtns.forEach(btn => {
				// save this once - we will need it when we re-render
				if (!btn.dataset.lang) {
					switch (btn.innerHTML.toLowerCase()) {
						case "english": btn.dataset.lang = "eng"; break;
						case "french": btn.dataset.lang = "fre"; break;
						case "floor": btn.dataset.lang = "mul"; break;
						default: btn.dataset.lang = "mul" // usually the file name
					}
				}
				let newLabel;
				switch (btn.dataset.lang) {
					case "eng": newLabel = english; break;
					case "fre": newLabel = french; break;
					case "mul": newLabel = multi; break;
					default: newLabel = btn.dataset.lang;
				}
				btn.ariaLabel = newLabel
				btn.innerHTML = newLabel
			})
		}
	}

	const renderPlayer = ()=> {
		if(playerID !== null && props.playlist.file !== null && process.env.REACT_APP_JWPLAYER_KEY && process.env.REACT_APP_JWPLAYER_SCRIPT) {
			fixAudioTracksButtonLabels()
			return (
				<ReactJWPlayer
					playlist={[props.playlist]}
					licenseKey={process.env.REACT_APP_JWPLAYER_KEY}
					playerId={playerID}
					playerScript={process.env.REACT_APP_JWPLAYER_SCRIPT}
					onPlay={() => onPlay()}
					onReady={()=>onAudioTracksLoaded()}
					onResume={() => onResume() &&props.setShowCPACTV &&  props.setShowCPACTV(false)}
					onPause={() => props.setShowCPACTV && props.setShowCPACTV(true)}
					isAutoPlay={props.autoplay}
					isMuted={false}
					customProps={{
						intl: {
						  en: {
							errors: {
							  badConnection: "This video will be available momentarily.",
							  cantLoadPlayer: "This video will be available momentarily.",
							  cantPlayInBrowser: "This video will be available momentarily.",
							  cantPlayVideo: "This video will be available momentarily.",
							  liveStreamDown: "This video will be available momentarily.",
							  protectedContent: "This video will be available momentarily.",
							  technicalError: "This video will be available momentarily.",
							},
						  },
						  fr: {
							errors: {
							  badConnection: "Cette vidéo sera disponible sous peu.",
							  cantLoadPlayer: "Cette vidéo sera disponible sous peu.",
							  cantPlayInBrowser: "Cette vidéo sera disponible sous peu.",
							  cantPlayVideo: "Cette vidéo sera disponible sous peu.",
							  liveStreamDown: "Cette vidéo sera disponible sous peu.",
							  protectedContent: "Cette vidéo sera disponible sous peu.",
							  technicalError: "Cette vidéo sera disponible sous peu.",
							},
						  },
						},
					  }}  
				/>
			)
		}
	}

	return (
		<>
			{props.playlist && renderPlayer()}
		</>
	)

}

const mapStateToProps = (store) => ({
    current_lang: store.language.current
});

export default connect(mapStateToProps, null)(ReactJWPlayerContainer);
